import styled from "styled-components";

export const DetailContainer = styled.div`
  padding: 20px;
  width: 100%;
`;

export const DetailTitle = styled.h2`
  text-align: center;
  margin-bottom: 30px;
  font-size: 24px;
  font-weight: 500;
`;

export const DetailSection = styled.div`
  margin-bottom: 30px;
  
  h3 {
    text-align: left;
    font-size: 20px;
    margin-bottom: 30px;
    padding-bottom: 10px;
    border-bottom: 2px solid #f0f0f0;
  }
`;

export const DetailRow = styled.div`
  display: flex;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
  
  &:last-child {
    border-bottom: none;
  }
`;

export const DetailLabel = styled.div`
  font-weight: 500;
  width: 200px;
  flex-shrink: 0;
  text-align: left;
`;

export const DetailValue = styled.div`
  flex: 1;
  text-align: center;

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  li {
    padding: 4px;
  }
`;
